export enum PaymentType {
  None = 0,
  Card = 1,
  Mobilepay = 2,
}
